export default __webpack_public_path__ + "static/art-pt2-world-map-700568d4500d1bf5f5e5ddd91fe3008d.jpg";